module.exports = __webpack_public_path__ + "static/media/fence.b9dc587c.jpg";